/* unplugin-vue-components disabled */import { render } from "./OpticalPathQuestionSelector.vue?vue&type=template&id=0f5dbe1d&scoped=true"
import script from "./OpticalPathQuestionSelector.vue?vue&type=script&lang=js"
export * from "./OpticalPathQuestionSelector.vue?vue&type=script&lang=js"

import "./OpticalPathQuestionSelector.vue?vue&type=style&index=0&id=0f5dbe1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5dbe1d"]])

export default __exports__